<main id="main-content" tabindex="-1">
    @if (canAdd) {
        <div class="md:flex md:flex-row justify-end mt-4">
        <prism-btn
          btnClass="md:mt-2 bg-white text-dark-purple font-bold border-2 p-0 m-0 rounded-xl border-dark-purple md:mx-[100px]"
          (click)="goToResourcesForm()">
          <i class="uil uil-plus text-dark-purple font-bold pr-1"></i
            >Add Resource
        </prism-btn>
      </div>
      }
    <div class="container mx-auto my-10 md:px-20 px-0">
      <prism-title additionalClasses="title text-4xl" title="Resources"></prism-title>

      <p class="mb-[30px] description">
        The following resources are created by other public and private organizations. These links are provided for your
        convenience. The California Department of Education does not control or guarantee the accuracy, relevance, timeliness,
        or completeness of this outside information. Nor does it endorse any views expressed or products or services offered
        on these outside sites, or the organizations sponsoring the sites.
      </p>
      <prism-card-list
        [dataList]="resourceList"
        (cardClick)="viewResource($event)">
      </prism-card-list>
    </div>
</main>
